import { Clipboard } from "@capacitor/clipboard";
import { createSignal } from "solid-js";

import { CheckIcon, CopyToClipboardIcon } from "./icons";

export default function CopyButton(props: { text: string }) {
  const [copied, setCopied] = createSignal(false);
  const copy = async () => {
    await Clipboard.write({
      string: props.text,
    });
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <button class="btn btn-ghost btn-square btn-sm" onClick={copy}>
      {copied() ? (
        <CheckIcon class="size-5" />
      ) : (
        <CopyToClipboardIcon class="size-5" />
      )}
    </button>
  );
}
